import isPremiumStatus from './isPremiumStatus';
import getName from './getName';
import isAuthenticated from './isAuthenticated';
import isLoading from './isLoading';

export default {
  isPremiumStatus,
  isAuthenticated,
  isLoading,
  getName,
};
